import React from "react";
import { BookOpen, Briefcase, Users, Cpu, TrendingUp, Award } from "lucide-react";
import { PageHero } from "../components/FormKit";

const TOPICS = [
  { icon: Briefcase, title: "Business", text: "Foundations of building and running a business." },
  { icon: TrendingUp, title: "E-Commerce", text: "Selling, scaling, and marketplace strategy." },
  { icon: Award, title: "Leadership", text: "Lead teams and grow influence." },
  { icon: Cpu, title: "Technology", text: "Tools and systems for modern commerce." },
  { icon: Users, title: "Networking", text: "Build relationships that compound." },
  { icon: BookOpen, title: "Growth", text: "Personal and professional development." },
];

export const KnowledgeHub = () => (
  <div data-testid="knowledge-hub-page">
    <PageHero eyebrow="TAVEN Knowledge Hub" title="Learn business, e-commerce, and leadership" subtitle="Learn business, e-commerce, leadership, technology, networking, and growth through TAVEN Knowledge Hub." />
    <section className="py-14 px-4 md:px-8 lg:px-12 mx-auto max-w-7xl grid grid-cols-2 md:grid-cols-3 gap-4">
      {TOPICS.map((t) => (
        <div key={t.title} className="p-6 bg-white border border-black/5 hover-lift"><t.icon className="w-8 h-8 text-taven-gold" /><h3 className="text-lg font-black font-display mt-3">{t.title}</h3><p className="text-sm text-muted-foreground mt-1">{t.text}</p></div>
      ))}
    </section>
    <div className="text-center pb-16"><div className="inline-block border border-dashed border-black/20 px-8 py-6"><p className="font-display font-bold text-lg">Courses & Resources</p><p className="text-sm text-muted-foreground">Coming Soon to the TAVEN ecosystem.</p></div></div>
  </div>
);

export default KnowledgeHub;
